import { useSyncExternalStore } from "react";

let pending = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

/**
 * Marks a page load as running until `request` settles.
 *
 * usePageData calls this while a page renders. Telling the subscribers right away would update the
 * navigation progress bar in the middle of that render, which React warns about ("cannot update a
 * component while rendering a different component"), so they hear of it a microtask later.
 */
export const trackPageLoad = (request: Promise<unknown>) => {
    pending++;
    queueMicrotask(emit);
    const done = () => {
        pending--;
        emit();
    };
    request.then(done, done);
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

/** True while any page is waiting for its data. */
export const usePageLoading = () => useSyncExternalStore(subscribe, () => pending > 0);
